/**
 * Web-only games and floor changes (user, 2026-09-27: "this change only
 * needs to apply to the non-glasses version").
 *
 * src/engine is byte-identical with the glasses game, so nothing here edits
 * it. Instead, at startup, this adds the web's own games to the engine's
 * game list and rearranges the floor lists the engine reads (it reads both
 * live, every time). Import this before anything else runs.
 */
import { FLOORS } from '../engine/floors';
import { GAMES } from '../engine/games';
import type { CasinoGame, GameId } from '../engine/games/types';
import { UPGRADES, type UpgradeId } from '../engine/shop';
import { PACHINKO, pachinko } from './pachinko';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(GAMES as Record<string, CasinoGame<any>>)[PACHINKO] = pachinko;

/** Pachinko takes Plinko's place in the Penthouse; Plinko moves down to the
 *  High Limit Room. */
const PLINKO = 'plinko' as GameId;
const highLimit = FLOORS.find((f) => f.id === 4)!;
const penthouse = FLOORS.find((f) => f.id === 5)!;
penthouse.newGames = penthouse.newGames.map((id) => (id === PLINKO ? PACHINKO : id));
if (!highLimit.newGames.includes(PLINKO)) highLimit.newGames = [...highLimit.newGames, PLINKO];

/** The Gift Shop follows: Install Plinko unlocks where Plinko now is, and
 *  Pachinko can be installed like every other game above the Main Floor. */
const installPlinko = UPGRADES.find((u) => u.id === `install:${PLINKO}`);
if (installPlinko) installPlinko.unlockFloor = highLimit.id;
const installPachinko = `install:${PACHINKO}` as UpgradeId;
if (!UPGRADES.some((u) => u.id === installPachinko)) {
  const at = UPGRADES.findIndex((u) => u.id === 'vip');
  UPGRADES.splice(at < 0 ? UPGRADES.length : at, 0, {
    id: installPachinko,
    name: 'Install Pachinko',
    effect: 'Play Pachinko on every floor, starting from the Main Floor, in every run.',
    price: 15000,
    unlockFloor: penthouse.id,
  });
}

export { PACHINKO };
